import { z } from 'zod'
import { IsoDateTime } from './common'

// What can start a workflow from outside: webhooks and RabbitMQ queues (entry 33).

export const WebhookEndpoint = z.object({
  id: z.string(),
  workspaceId: z.string(),
  workflowId: z.string(),
  path: z.string().describe('/hooks/{workspace}/{workflow}'),
  mode: z
    .enum(['sync', 'async'])
    .describe('sync = wait up to waitSeconds for an answer; async = 202 at once'),
  waitSeconds: z.number().int().min(0).max(20),
  secretHint: z.string(),
  callCount: z.number().int().default(0),
  lastCalledAt: IsoDateTime.nullable().default(null),
  createdAt: IsoDateTime,
})
export type WebhookEndpoint = z.infer<typeof WebhookEndpoint>

export const WebhookEndpointInput = WebhookEndpoint.pick({ workflowId: true, mode: true, waitSeconds: true })
export type WebhookEndpointInput = z.infer<typeof WebhookEndpointInput>

export const WebhookCreated = z.object({ endpoint: WebhookEndpoint, secretShownOnce: z.string() })
export type WebhookCreated = z.infer<typeof WebhookCreated>

export const EventSubscription = z.object({
  id: z.string(),
  workspaceId: z.string(),
  workflowId: z.string(),
  queue: z.string().describe('declared in firstfund-platform (rabbitmq-init)'),
  eventName: z.string().describe('e.g. lead.created'),
  eventSchema: z.string().optional().describe('firstfund-contracts schema id'),
  eventCount: z.number().int().default(0),
  lastEventAt: IsoDateTime.nullable().default(null),
  createdAt: IsoDateTime,
})
export type EventSubscription = z.infer<typeof EventSubscription>

export const EventSubscriptionInput = EventSubscription.pick({
  workflowId: true,
  queue: true,
  eventName: true,
  eventSchema: true,
})
export type EventSubscriptionInput = z.infer<typeof EventSubscriptionInput>
